const PrintServiceWeb = {
    async init() { },
    async detectPrinters() {
        return [];
    },
    async sendToPrinter(printer, data) {
        return { success: false, error: 'not_supported' };
    },
    async openDrawer(printer) {
        return { success: false, error: 'not_supported' };
    },
    async canPrintLogo() {
        return false;
    },
};
export default PrintServiceWeb;
//# sourceMappingURL=PrintServiceWeb.js.map